var _path, _path2, _circle, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityBannerMobile = function SvgSecurityBannerMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311,
    height: 202,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M15.17 37.771s13.05 6.127 24.855-2.075c6.37-4.407 9.073-12.823 8.239-17.941-.639-3.905-3.436-5.677-5.447-4.61-2.35 1.207-2.168 4.65-.387 6.718 3.038 3.523 10.336 5.514 15.84.997 5.98-4.903 4.397-12.363 4.397-12.363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    d: "M300 16.895v.217c-2.752 0-4.355 1.86-4.355 4.888h-.273c0-3.052-1.675-4.888-4.372-4.888v-.217c2.725 0 4.372-1.861 4.372-4.895h.273c0 3.04 1.603 4.895 4.355 4.895"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 178,
    r: 2.6,
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    d: "M291 180.937v.13c-1.835 0-2.903 1.117-2.903 2.933h-.183c0-1.831-1.116-2.933-2.914-2.933v-.13c1.816 0 2.914-1.117 2.914-2.937h.183c0 1.824 1.068 2.937 2.903 2.937M266 13.937v.13c-1.835 0-2.903 1.117-2.903 2.933h-.183c0-1.831-1.116-2.933-2.914-2.933v-.13c1.816 0 2.914-1.117 2.914-2.937h.183c0 1.824 1.068 2.937 2.903 2.937"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 57.5,
    r: 1.5,
    fill: "var(--color-main-text, #EBEBEB)"
  })));
};
export default SvgSecurityBannerMobile;